export default {
  ColorPicker: {
    almond: 'Almond',
    aluminium: 'Aluminium',
    blue: 'Blue',
    cobalt: 'Cobalt',
    copper: 'Copper',
    coral: 'Coral',
    forestGreen: 'Forest Green',
    gold: 'Gold',
    indigo: 'Indigo',
    irishCoffee: 'Irish Coffee',
    lavender: 'Lavender',
    lightBlue: 'Light Blue',
    limeGreen: 'Lime Green',
    marzipan: 'Marzipan',
    midnightBlue: 'Midnight Blue',
    niagara: 'Niagara',
    oceanBlue: 'Ocean Blue',
    pumpkin: 'Pumpkin',
    red: 'Red',
    redBerry: 'Red Berry',
    redViolet: 'Red Violet',
    rubyRed: 'Ruby Red',
    sandstone: 'Sandstone',
    shadyGray: 'Shady Gray',
  },
  DatePicker: {
    inputHelp: 'Submit the date by pressing ↵',
  },
  HelpMenu: {
    version: 'v {id}',
    status: 'App Status',
  },
  ReleaseInfo: {
    button: 'This is new',
    text: 'koppla has been updated',
  },
  MultiSelectActionSnackbar: {
    finish: 'Finish',
  },
  MultiSubSelect: {
    andMore: '(+{n} more)',
    deselectAllSearchResults: 'Deselect all items matching the search',
    selectAllSearchResults: 'Select all items matching the search',
  },
  DsNameSelect: {
    notFound: 'Name not found',
  },
  Autocomplete: {
    empty: 'No selection available',
    nothingFound: 'Nothing found',
  },
  DsTable: {
    paginationBack: 'Previous',
    paginationNext: 'Next',
  },
  DsError: {
    moreInfo: 'More information',
  },
  UserSelect: {
    notFound: 'No such member found',
  },
  CopyButton: {
    copy: 'Copy',
    copied: 'Copied',
  },
  SortButton: {
    title: 'Sort',
    description: 'Sorting',
    ascending: 'Ascending',
    descending: 'Descending',
  },
};
